import { render } from "./choosepart.vue?vue&type=template&id=088e1cd9"
import script from "./choosepart.vue?vue&type=script&lang=js"
export * from "./choosepart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__